<template>
    <div>
        <Header />
        <DropdownMenu />
        <router-view />
    </div>
</template>
<script>
    import Header from '../../components/core/Header';
    import DropdownMenu from '../../components/core/DropdownMenu';
    export default {
        name: "Home",
        components: {
            Header,
            DropdownMenu
        }
    }
</script>